// extracted by mini-css-extract-plugin
export default {"pane":"ContentPane_pane__RYDD+"};